__turbopack_context__.v({
  "content": "Paper-module__jgSYcG__content",
  "revealBorder": "Paper-module__jgSYcG__revealBorder",
  "revealBorderSolid": "Paper-module__jgSYcG__revealBorderSolid",
  "root": "Paper-module__jgSYcG__root",
});
